import {Typography, useTheme, css} from '@mui/material';
import {asQueryStrings, DlMuiPopper, GetStylesFunction, mixins, useMuiAnchor} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {useIntl} from 'react-intl';

import {EntityLink} from 'src/js/containers/file/components/EntityLink';
import {ROUTE_HOSPITALIZATIONS} from 'src/js/containers/hospitalizations';
import {baseHospitalizationsListLinkFormatterParams} from 'src/js/lib/raw_rendering/base_hospitalizations_list_link_formatter_params';

type OwnProps = ICellRendererParams;

type Props = OwnProps & {
  versionSuffix?: string; // eslint-disable-line react/no-unused-prop-types
  wrapperStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  value: string | React.ReactNode;
  tooltip?: string | React.ReactNode;
  phRecId?: string;
};

export const HospitalizationsLinkFormatter: React.FC<Props> = (props) => {
  const {value, tooltip: outerTooltip, wrapperStyle, style, phRecId} = props;
  const intl = useIntl();
  const {id, versionSuffix = ''} = baseHospitalizationsListLinkFormatterParams(props, {
    intl,
  });

  const tooltip = outerTooltip ?? value;
  const hasTooltip = Boolean(tooltip);

  const {mouseEventEnter, mouseEventLeave, open, anchorEl} = useMuiAnchor(hasTooltip);

  const theme = useTheme();
  const styles = getStyles({theme});

  const searchParams = asQueryStrings({
    rightTabs: phRecId != null ? 1 : 0,
    phRecItem: {openedItemId: phRecId},
  });

  // REFACTOR: don't wrap the entire thing in Typography, as it adds `line-height`, which then breaks height
  return (
    <Typography style={wrapperStyle} css={styles.wrapper} variant={'textButton'}>
      {/* TODO-JK: uncomment and restyle when hospitalizations detail will be implemented */}
      <div css={styles.dlLinkFormatter}>
        <EntityLink id={id} route={ROUTE_HOSPITALIZATIONS + versionSuffix} searchParams={searchParams} suppressPadding>
          <span style={style} css={styles.span} onMouseEnter={mouseEventEnter} onMouseLeave={mouseEventLeave}>
            {value}
          </span>
          <DlMuiPopper hasTooltip={hasTooltip} anchorEl={anchorEl} open={open}>
            <Typography variant={'popper'}>{tooltip}</Typography>
          </DlMuiPopper>
        </EntityLink>
      </div>
    </Typography>
  );
};

HospitalizationsLinkFormatter.displayName = 'HospitalizationsLinkFormatter';

const getStyles: GetStylesFunction = (options) => ({
  span: css`
    line-height: 22px;
    display: inline-block;
    width: 100%;
    ${mixins.dlTextOverflowEllipses};
    text-decoration: underline;
    padding: ${options?.theme?.spacing(1, 0)};
  `,
  wrapper: css`
    line-height: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  dlLinkFormatter: css`
    ${mixins.dlTextOverflowEllipses};
    min-width: 0;
  `,
});
